import {SelectDateInputWrapper} from '@molecules/SelectDateInput.styles';
import styled from 'styled-components';
import {fontStyles, theme} from '@styles/theme';

export const CalendarWrapper = styled(SelectDateInputWrapper)`
  width: 280px;
  align-self: center;
  .react-calendar__viewContainer {
    display: block !important;
  }
  .react-calendar__viewContainer > * {
    width: 100% !important;
  }
  .react-calendar__viewContainer > *:first-child {
    border-right: 0 !important;
  }
  .react-calendar {
    width: 100%;
    background: transparent !important;
  }
`;

export const CalendarHeadersRow = styled.div`
  display: grid;
  grid-template-columns: 28px 1fr 28px;
  align-items: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;
  padding: 0 16px;
`;

export const CalendarHeaderCell = styled.div`
  ${fontStyles.bodyM};
  text-align: center;
  text-transform: capitalize;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 16px 0px;
  color: ${theme.colors.basic01};
`;

export const SelectedDateInfo = styled.div`
  padding: 8px 16px;
  align-self: center;
  gap: 16px;
  display: flex;
  flex-direction: column;
`;
